import request from '../services/index';
import Cookies from 'js-cookie';
import qs from 'qs';
import Vue from 'vue';

let { SSO_HOST, SERVER_HOST, SSO_CLIENTID } = window;

// let FE_HOME = location.origin + location.pathname;

let queryString = location.search.slice(1);
let queryObj = qs.parse(queryString);
if (queryObj.code) {
    queryObj.code = undefined;
}

if (queryObj.webNewUuid) {
    queryObj.webNewUuid = undefined;
}

if (queryObj.moaDeviceId) {
    queryObj.moaDeviceId = undefined;
}

if (queryObj.t) {
    queryObj.t = undefined;
}
queryString = qs.stringify(queryObj);
let FE_HOME = location.origin + location.pathname + (queryString ? '?' + queryString : '');

let cookieKey = `${SSO_CLIENTID}_fe_ssoid`;
let cookieKey2 = `${SSO_CLIENTID}_ssoid`;

let setCookie = (token) => {
    Cookies.set(cookieKey, token);
    Cookies.set(cookieKey2, token);
};

let ssoUtil = {
    getAccessToken: async (code) => {
        debugger;
        try {
            let res = await request({
                path: '/sso/callback',
                method: 'get',
                params: {
                    code: code,
                    'original-url': FE_HOME, // http://localhost:8089
                },
                responseType: 'text'
            });
            console.log('getAccessToken:accessToken', res);
            debugger;
            return res;
        } catch (e) {
            // 理论上讲 这个也是不会报错的
            debugger;
            ssoUtil.redirect();
        }
    },

    getCode: () => {
        // let queryString = location.hash.replace('#/', '').replace('?', ''); // hash
        let queryString = location.search.replace('?', '');
        let qsObj = qs.parse(queryString);
        if (qsObj.code) {
            return qsObj.code;
        }
        return false;
    },

    // 检测query中是否有code，如果有的的，走code换access_token的逻辑
    checkCode: async () => {
        let code = ssoUtil.getCode();
        if (code) {
            let accessToken = await ssoUtil.getAccessToken(code);
            console.log('checkCode:accessToken', accessToken);
            debugger;
            if (accessToken) {
                console.log('checkCode:设置cookie', cookieKey, accessToken);
                setCookie(accessToken);
                console.log('checkCode:完成cookie', Cookies.get(cookieKey), document.cookie);
                console.log(FE_HOME);
                location.href = FE_HOME;
                debugger;
            } else {
                // 神马 换code还能失败？你说，你的code是不是乱写的？
                console.log('checkCode:error', accessToken);
                debugger; // 这个debugger一定要保留
                ssoUtil.redirect();
            }
        }
    },

    // 检测accessToken是否存在和生效
    checkToken: async () => {
        if (ssoUtil.getCode()) {
            return void 0;
        }
        let accessToken = Cookies.get(cookieKey);
        let accessToken2 = Cookies.get(cookieKey2);
        let dTokenFlag = accessToken === accessToken2; // 两个cookie是否相等

        // 不相等但是无法写入cookie就说明是http only的cookie 默认不处理 否则会死循环
        if (!dTokenFlag) {
            let bToken = Cookies.get(cookieKey2);
            Cookies.set(cookieKey2, 'test');
            if (Cookies.get(cookieKey2) === 'test') {
                Cookies.set(cookieKey2, bToken);
            } else {
                dTokenFlag = true;
                localStorage.setItem('access-token', accessToken2);
            }
        }
        localStorage.setItem('access-token', accessToken);
        if (accessToken && dTokenFlag) {
            try {
                let res = await request({
                    path: '/brain-api/v1/username',
                    method: 'get',
                    params: {}
                });
                if (!res) {
                    debugger;
                    ssoUtil.redirect();
                }
                // 没有登录
                if (res.code === 401) {
                    debugger;
                    ssoUtil.redirect();
                }
                window.username = res.data && res.data.username;
                return res;
            } catch (e) {
                Vue.prototype.$message.error('SSO登陆出现错误' + e);
                debugger;
                // ssoUtil.redirect();
            }
        } else {
            debugger;
            ssoUtil.redirect();
        }
    },
    login: async () => {
        // 先看看是不是在接收code然后再看鉴权的事情
        await ssoUtil.checkCode();
        await ssoUtil.checkToken();
    },
    redirect: () => {
        let urlToSSO = `${SSO_HOST}/sson/login?redirect_uri=${encodeURIComponent(FE_HOME)}&client_id=${SSO_CLIENTID}`;

        console.log(FE_HOME);
        debugger;
        location.href = urlToSSO;
    }
};

export default ssoUtil;
